<template>
    <transition name="fade" @before-leave="beforeLeaveHandler">
        <div class="login-pop">
            <div class="main">
                <Icon type="md-close" class="close-icon" @click="$emit('close-login')"></Icon>
                <div class="left-box">
                    <img class="login-register-img" src="@/assets/images/login-register-img.png" />
                </div>
              
                <div class="right-box">
                    <div class="title">{{ pop_type == 'login' ?'Login':'Sign up' }}</div>
                    <div class="form-content" v-if="pop_type == 'login'">
                        <div class="item-title">{{ $t("login.email")}}</div>
                        <div class="form-item">
                           <input  v-model="form_data.email"
                                    placeholder="Enter email"
                                    type="text" />
                        </div>
                        <div class="item-title">Password</div>
                        <div class="form-item">
                           <input v-model="form_data.password"
                                    placeholder=" Enter your password"
                                    :type="password_type" />
                            <div class="eye-box">
                            <img @click="toggle_password()"
                                :src="password_type == 'text' ? require('@/assets/images/icon-open-eye.png') : require('@/assets/images/icon-close-eye.png')"
                                style="width:18px;height:12px;" />
                            </div>        
                        </div>
                        <div class="flex align-center justify-between margin-top-20">
                           <label @click="rememberMe()">
                            <Checkbox v-model="remember_me" color="#ff5967" :checked="remember_me" ></Checkbox>
                            <span class="text-333 text-12">Remember me</span>
                           </label>
                          <span class="text-666 text-12 pointer" @click="go2find">Forgot your password?</span>
                        </div>
                        <button class="btn-submit margin-top-30" @click="submit">Sign In</button>
                        <div class="text-666 text-12 text-center margin-top-20"> By logging in, you agree to <span class="text-333" style="cursor:pointer" @click="open_agreement">our terms</span>  and <span class="text-333" style="cursor:pointer" @click="open_agreement">privacy policy</span></div>
                        <div class="line margin-top-30"></div>
                        <div class="text-black margin-top-30 text-center text-16">Don't have an account?</div>
                        <button class="btn-to-sign margin-top-30" @click="pop_type = 'register'">Create Account</button>
                        
                    </div>  
                    <div class="form-content" v-if="pop_type == 'register'">
                        <div class="item-title">Email</div>
                        <div class="form-item">
                           <input  v-model="form_data_register.email"
                                    placeholder="Enter email"
                                    type="text" />
                        </div>
                        <div class="item-title">Password</div>
                        <div class="form-item">
                           <input v-model="form_data_register.password"
                                    placeholder=" Enter your password"
                                    :type="password_type" />
                            <div class="eye-box">
                            <img @click="toggle_password()"
                                :src="password_type == 'text' ? require('@/assets/images/icon-open-eye.png') : require('@/assets/images/icon-close-eye.png')"
                                style="width:18px;height:12px;" />
                            </div>        
                        </div>
                        <div class="item-title">Code</div>
                        <div class="form-item">
                          <input style="" v-model="form_data_register.code" placeholder="Enter code" />
                          <email-code class="btn-code" scene="register" :email="form_data_register.email"></email-code>
                        </div>
                        <div class="flex align-center justify-between">
                            <div class="">
                                <div class="item-title">First name</div>
                                <div class="form-item">
                                    <input  v-model="form_data_register.first_name"
                                                placeholder="First name"
                                                type="text" />
                                </div>
                            </div>
                            <div class="">
                                <div class="item-title">Last name</div>
                                <div class="form-item">
                                    <input  v-model="form_data_register.last_name"
                                                placeholder="Last name"
                                                type="text" />
                                </div>
                            </div>
                        </div>
                         <button class="btn-submit margin-top-30" @click="submit">Create Account</button>
                        <div class="text-666 text-12 text-center margin-top-20"> By logging in, you agree to <span class="text-333" style="cursor:pointer" @click="open_agreement">our terms</span>  and <span class="text-333" style="cursor:pointer" @click="open_agreement">privacy policy</span></div>
                        <div class="line margin-top-20"></div>
                        <div class="text-black margin-top-20 text-center text-16">Already have an account</div>
                        <button class="btn-to-sign margin-top-20" @click="pop_type = 'login'">Sign In</button>
                       
                    </div>  
                </div>
            </div>
            <popup :show.sync="is_popup_show" width="680px" height="520px" @on-close="close_agreement">
              <div class="agree-content">
                <div v-html="setting.userAgreement"></div>
              </div>
            </popup>
        </div>
    </transition>
</template>
<script>
import {
  AccountLogin,
  Profile,
  Register,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { mapState } from 'vuex';
import EmailCode from "./EmailCode.vue";

export default {
  name: "LoginPop",
  components: {
    EmailCode,Popup
  },
  props: {
    type: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      form_data_register: {
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        code:""
      },
      form_data: {
        email: "",
        password: "",
      },
      is_password_show: false,
      pop_type: "login",
      is_click: false,
      remember_me: false,
      is_popup_show: false,
    };
  },
  watch: {
    is_agree(news, olds) {
      console.log("news", this.is_agree);
    },
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
    }),
    password_type() {
      return this.is_password_show ? "text" : "password";
    },
  },
  mounted() {
    // 锁定页面滚动
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
    // document.body.style.position = 'fixed';
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";
    this.pop_type = this.type;
    const remember_cache = localStorage.getItem("remember_form");
    if (remember_cache) {
      const form_data = JSON.parse(remember_cache);
      this.form_data.email = form_data.account;
      this.form_data.password = form_data.key;
      this.remember_me = true;
    }else{
      this.remember_me = false;
    }
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    document.body.style.height = "";
    // document.body.style.position = '';
    document.body.style.width = "";
    document.documentElement.style.overflow = "";
  },
  methods: {
    close_agreement() {
				this.is_popup_show = false
			},
    open_agreement() {
      this.is_popup_show = true
    },
    submit() {
      if (this.is_click) {
        return;
      }
      if(this.pop_type === 'login'){
        const remember_before = localStorage.getItem('remember_form');
        this.form_data.is_remember = this.remember_me || !!remember_before;
        if (!this.form_data.email || !this.form_data.password) {
          this.$layer.msg(`Please enter your account password`);
          return;
        }
      }else{
        if(!this.form_data_register.email || !this.form_data_register.password){
          this.$layer.msg('Please enter your account password');
          return;
        }
        if(!this.form_data_register.code){
          this.$layer.msg(`Please enter verification code`);
          return;
        }
      }

      this.is_click = true;
      let promise = new Promise((resolve, reject) => {
        let response;
        let msg
        if (this.pop_type === "login") {
            msg = 'Login Fail'
          response = AccountLogin(this.form_data);
          resolve(response);
        }
        if (this.pop_type === "register") {
             msg = 'Register Fail'
          response = Register(this.form_data_register);
          resolve(response);
        }
        reject({ msg});
      });
      promise
        .then((response) => {
          if(this.remember_me){
            const remember_form = {};
            remember_form.account = this.form_data.email;
            remember_form.key = response.data.key;
            console.log('remember_form',remember_form);
            localStorage.setItem("remember_form", JSON.stringify(remember_form));
          }else{
            if(!this.remember_me){
              localStorage.removeItem("remember_form");
            }
          }
          this.$store.commit("login", response.data);
          return Profile();
        })
        .then((response) => {
          this.$store.commit("setUserInfo", response.data);
        })
        .then(() => {
          this.$store.dispatch("getUser");
          this.$emit("close-login");
        });
      promise.catch((res) => {
        this.$layer.msg(res.msg);
      });
      promise.finally(() => {
        this.is_click = false;
      });
    },

    toggle_password() {
      this.is_password_show = !this.is_password_show;
    },
    rememberMe() {
      this.remember_me = !this.remember_me;
    },
    go2find() {
      this.$emit('close-login');
      this.$router.push({ name: "FindPwd" });
    },
    beforeLeaveHandler(el) {
      // 定义随机方向参数
      const dx = (Math.random() - 0.5) * 200; // 水平方向随机偏移（-100~+100）
      const dy = (Math.random() - 0.5) * 100; // 垂直方向随机偏移（-50~+50）
      const scale = Math.random() * 0.5 + 0.1; // 随机缩放比例（0.1~0.6）

      // 动态设置元素样式
      el.style.transition = "all 0.3s ease-out";
      el.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
      el.style.opacity = "0";
    },
  },
};
</script>
<style lang="scss" scoped>
.login-pop {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.25);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 201;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }

  // overflow:hidden;
  transform-origin: center;
  animation: centerExpand 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  /* 添加缓动曲线 */
  @keyframes centerExpand {
    0% {
      transform: scale(0.8) translateY(-10px);
      /* 初始状态缩小+上移 */
      opacity: 0;
    }

    100% {
      transform: scale(1) translateY(0);
      /* 完全显示 */
      opacity: 1;
    }
  }

  &.fade-leave-active {
    transition: all 0.3s ease-out;
  }

  .main {
    border-radius: 15px;
    position: relative;
    // height: 550px;
    height:auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    .close-icon {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 19px;
      cursor: pointer;
    }

    .left-box {
      width: 450px;
      height: 650px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-box {
      width: 500px;
      height: 650px;
      padding: 0 35px;
      background-color: #ffffff;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;

      .title {
        font-size: 24px;
        line-height: 24px;
        color: #000000;
        font-weight: bold;
        margin-top: 36px;
      }
      .line {
        width: 430px;
        height: 1px;
        background: #e5e5e5;
      }
      .btn-submit {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #212121;
        color: white;
        border-radius: 2px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
      }
      .btn-to-sign {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #ffffff;
        color: white;
        border-radius: 2px;
        font-size: 14px;
        color: #000000;
        cursor: pointer;
        border: 1px solid #212121;
      }

      .form-content {
        width: 100%;
        .item-title {
          margin-top: 20px;
          font-size: 14px;
          line-height: 14px;
          color: #000000;
        }
        .form-item {
          background: #ffffff;
          width: 100%;
          height: 40px;
          border-radius: 2px;
          display: flex;
          align-items: center;
          margin-top: 5px;
          box-sizing: border-box;
          border: 1px solid #cbcbcb;
          padding: 0 16px;
          .eye-box {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          input {
            border: none !important;
            background: transparent;
            outline: none !important;
            width: 93%;

            &:focus {
              border: none !important;
            }

            &:active {
              border: none !important;
            }
          }

          .btn-code {
            white-space: nowrap;
          }

          .mobile-prefix {
            border-right: 1px solid #e4e4e4;
            padding-left: 20px;
            padding-right: 15px;
            flex: 0 0 5%;
            color: #2c2e30;
            font-size: 14px;
          }
        }

        .under-form {
          margin-top: 10px;
          flex: 1;

          .login-mode {
            margin-left: 20px;
            cursor: pointer;

            .forget-pwd {
              color: #303234;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
::v-deep .popup-modal {
  /* 弹窗内容区 */
  .popup-content {
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(500px, 80vh); // 最大720px，最小占85%视口高
    height: 30vh;
    display: flex;
    flex-direction: column;
    .agree-content {
      overflow-y: scroll;
      max-height: max(480px, 70vh); // 最大720px，最小占85%视口高
      padding: 30px;
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;
      }
    }
  }
}

</style>
